module.exports = __webpack_public_path__ + "static/img/8.109e56f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/2/zh/8.png
// module id = vvPw
// module chunks = 0